import { createEvent, createStore, sample } from 'effector'

import { $creatorId } from '@/models/creators.ts'
import { MassMessageTablesTypes } from '@/modules/chatting/ui/sidebar/mass-messages-statistics/constants.ts'
import { resetNormalMassMessages } from '@/modules/chatting/ui/sidebar/mass-messages-statistics/models/normalMassMessagesStats.ts'
import { resetPriorityMassMessagesStats } from '@/modules/chatting/ui/sidebar/mass-messages-statistics/models/priorityMassMessagesStats.ts'

export const setFilterKey = createEvent<MassMessageTablesTypes>(
  'set mass messages filter key',
)
export const $filterKey = createStore<MassMessageTablesTypes | null>(null, {
  name: ' mass messages filter key',
}).on(setFilterKey, (_, key) => key)

sample({
  clock: setFilterKey,
  filter: (key) => key === MassMessageTablesTypes.NMM,
  target: resetNormalMassMessages,
})

sample({
  clock: setFilterKey,
  filter: (key) => key === MassMessageTablesTypes.PMM,
  target: resetPriorityMassMessagesStats,
})

sample({
  clock: $creatorId,
  source: { filterKey: $filterKey },
  filter: ({ filterKey }) => filterKey === MassMessageTablesTypes.NMM,
  target: resetNormalMassMessages,
})

sample({
  clock: $creatorId,
  source: { filterKey: $filterKey },
  filter: ({ filterKey }) => filterKey === MassMessageTablesTypes.PMM,
  target: resetPriorityMassMessagesStats,
})
